import { BillTypeEnum, InvoiceFinanceProvider, SafiVatEnum } from 'api';
import { yup } from 'form';
import { translate } from 'i18n';

import { baseSalesOrderFormSchema } from './baseSalesOrderSchema';

export const updateSalesOrderSchema = baseSalesOrderFormSchema
  .shape({
    bank_details_id: yup.number().optional(),
    bill_type: yup.string().oneOf(Object.values(BillTypeEnum)).optional(),
    consignee_id: yup.number().optional(),
    date_fixed: yup.string().optional(),
    fixed_price: yup.string().optional(),
    invoice_finance_provider: yup.string().oneOf(Object.values(InvoiceFinanceProvider)).optional(),
    marks_and_numbers: yup.string().optional(),
    material_hs_code_override: yup.string().optional(),
    notify_party_id: yup.number().optional(),
    safi_vat: yup.string().oneOf(Object.values(SafiVatEnum)).optional(),
    shipper_id: yup.number().optional(),
    shipping_instruction_notes: yup.string().optional(),
  })
  .test(
    'fixed-price-date-dependency',
    translate('backlog.orders.validation.fixedPriceAndDateMustBeProvidedTogether', {
      namespace: 'features',
    }),
    function (values) {
      const hasFixedPrice = values.fixed_price !== undefined && values.fixed_price !== '';
      const hasFixedDate = values.date_fixed !== undefined && values.date_fixed !== '';

      if ((hasFixedPrice && !hasFixedDate) || (!hasFixedPrice && hasFixedDate)) {
        return this.createError({
          message: translate('backlog.orders.validation.fixedPriceAndDateMustBeProvidedTogether', {
            namespace: 'features',
          }),
          path: hasFixedPrice ? 'fixed_date' : 'fixed_price',
        });
      }

      return true;
    }
  );
